module.exports = __webpack_public_path__ + "static/media/28_B.6e3265a2.png";